import RangeField from "./RangeField";

export default RangeField;
